import React, { useState, useEffect, useCallback } from 'react';
import { useAppSelector, useAppDispatch } from 'store';
import { Card, Divider, Loader, Message } from 'semantic-ui-react';
import { useHistory, useLocation } from 'react-router-dom';
import { OpenAPI } from 'simplydo/interfaces';
import api from 'api';
import toast from 'react-hot-toast';
import actions from 'actions';

const CompleteVerifyEmail = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const user: OpenAPI.GET<'/users/me'> = useAppSelector((state) => state.user);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [emailVerified, setEmailVerified] = useState(false);

  const onEmailsUpdate = useCallback((emails) => dispatch(actions.user.updateEmails(emails)), [dispatch]);

  const verifyEmail = useCallback(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    setLoading(true);
    api.auth.verifyEmail(token, ({ emails }) => {
      setLoading(false);
      toast.success('Email address verified successfully');
      setEmailVerified(true);
      if (user) {
        onEmailsUpdate(emails);
        history.push('/');
      }
    }, (err) => {
      setLoading(false);
      setErrorMessage(err.message);
    });
  }, [history, location.search, onEmailsUpdate, user]);

  useEffect(() => {
    verifyEmail();
  }, [verifyEmail]);

  return (
    <Card.Group centered>
      <Card raised color="yellow" style={{ marginTop: 50 }}>
        <Card.Content>
          <Card.Header>Email verification</Card.Header>
          {loading
            ? (
              <Card.Meta>We are verifying your email address...</Card.Meta>
            ) : null
          }
          <Divider hidden />
        </Card.Content>
        <Card.Content textAlign="center">
          {emailVerified 
            ? (
              <Message info>
                <Message.Header>Email verified</Message.Header>
                <p>Your email address has been verified successfully. You can now close this tab and return to your previous SimplyDo tab.</p>
              </Message>
            ) : null
          }
          {loading && <Loader centered active inline />}
          {errorMessage && <Message color="orange">{errorMessage}</Message>}
        </Card.Content>
      </Card>
    </Card.Group>
  );
};

export default CompleteVerifyEmail;
